/******************************************************************************************
 *	Add Customer Modal (also used to Edit Customer)
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.addCustomerModal', ['app.core.country', 'binky.core.common.country'])
    .factory(
      'AddCustomerModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/add-customer-modal.html',
          controller: 'AddCustomerModalController',
          classNames: 'add-customer-modal'
        });
      }
    )
    .constant('ADD_CUSTOMER_MODAL_VIEW_STATE', {
      BASIC_INFO: 'BASIC_INFO',
      ORG_OPTIONS: 'ORG_OPTIONS'
    })
    .controller('AddCustomerModalController', addCustomerModalController);
  /* @ngInject */
  function addCustomerModalController(
    _,
    $log,
    $scope,
    $filter,
    ADD_CUSTOMER_MODAL_VIEW_STATE,
    COUNTRY_TO_LOCALE_MAP,
    DEFAULT_COUNTRY_LOCALE,
    feature,
    RESELLER_PREFERRED_LANGUAGES,
    PLAN_TYPE,
    REQUESTED_PLAN_TYPES,
    AddCustomerModal,
    AlertModal,
    AnniversaryDatesUtility,
    Customers,
    Customer,
    CurtainNotifications,
    CountryList,
    MarketSegments,
    moment,
    Regions,
    Settings,
    User,
    Utility,
    locale,
    IMSClient
  ) {
    // initialize in the basic info state
    $scope.viewState = ADD_CUSTOMER_MODAL_VIEW_STATE.BASIC_INFO;
    $scope.orgOptions = {
      customInitialTerm: false
    };
    // provide constant access to the template
    $scope.ADD_CUSTOMER_MODAL_VIEW_STATE = ADD_CUSTOMER_MODAL_VIEW_STATE;

    $scope.isEdit = !!$scope.customer; // either add, or edit, if a customer is provided

    $scope.resellerIsChinaOnly = User.getReseller().isChinaReseller;
    // The  differences between add/edit are the modal title, the text on the submit button,
    // and for Edit, populated customer data to edit.
    $scope.modalTitle = $scope.isEdit ? 'editCustomerModal.title' : 'addCustomerModal.title';
    $scope.formButtonSubmitText = $scope.isEdit
      ? 'editCustomerModal.formButtons.submit'
      : 'addCustomerModal.formButtons.submit';

    //Get segments
    $scope.loadingMarketSegments = true;
    MarketSegments.get().then(
      function(data) {
        $scope.loadingMarketSegments = false;
        // Looks like [{ id: "COMMERCIAL", label: "global.marketSegments.education" }, ... ]
        $scope.marketSegments = data;
      },
      function(response) {
        $scope.loadingMarketSegments = false;
        CurtainNotifications.show(
          CurtainNotifications.ERROR,
          'addCustomerModal.notifications.noMarketSegments'
        );
        $log.error('Failed to load market segments', response.data);
      }
    );

    // Expose preferred languages - [ { label: "language.english" value: "en" }  ...]
    // Values use '-' rather than '_'.
    $scope.preferredLanguages = RESELLER_PREFERRED_LANGUAGES;

    $scope.planTypes = REQUESTED_PLAN_TYPES;
    // If the plan type select element has focus, we disable the info tooltip (it looked bad on several
    // browsers when the select was opened and the tooltip would still show, behind it). Removing focus
    // from the select should re-enable the tooltip. So clicking on the 'i' icon would remove select focus
    // and show the tooltip, in the event that it won't show after choosing a value from the select.
    $scope.planSelectFocus = false;

    // Return the language object for the given locale.
    var getPreferredLanguageObject = function(locale) {
      return _.find($scope.preferredLanguages, function(element) {
        return (
          _.toLower(element.value) ===
          _(locale)
            .toLower()
            .replace('_', '-')
        );
      });
    };

    var appendPreferredLocales = function(countries) {
      return _.map(countries, function(country) {
        return _.assign(
          {
            countryLocale: COUNTRY_TO_LOCALE_MAP[country.countryCodeISO3] || DEFAULT_COUNTRY_LOCALE
          },
          country
        );
      });
    };

    // 13 – 36 months duration for Commercial customers
    // 13 – 50 months duration for Government & Education customers
    // We put all our dates in a format that sets them to be 12:01am in Pacific Time, since that's what the server
    // will convert it to anyway. This way we display in the selection the correct local date for the date/time that
    // the back end will use for the anniversary date passed in.
    var calculateExtendedTermDates = function() {
      const segment = _.get($scope, 'marketSegment.id');
      const userRole = User.getRole();

      // Default anniversary date is 13 months from today
      let defaultAnniversaryDate = AnniversaryDatesUtility.getDefaultAnniversaryDate();
      // anniversary date based on segment.
      let maxDate = AnniversaryDatesUtility.getMaxAnniversaryDateForSegment(segment);

      // Override defaultAnniversaryDate and maxDate for LICENSE_ADMIN_READ_WRITE role.
      if (_.includes(['LICENSE_ADMIN_READ_WRITE', 'LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER'], userRole)) {
          defaultAnniversaryDate = AnniversaryDatesUtility.getMomentMonthsAwayWithFormat(2, 15);
          maxDate = AnniversaryDatesUtility.getMomentMonthsAwayWithFormat(120);
          $scope.anniversaryData.initialTermDuration = 1;
      }

      $scope.customAnniversaryMonths = AnniversaryDatesUtility.getAnniversaryDateMonths(maxDate, defaultAnniversaryDate);

      $scope.anniversaryData.minimumAnniversaryDate = defaultAnniversaryDate;
      $scope.anniversaryData.maximumAnniversaryDate = maxDate;
      if (
        $scope.anniversaryData.anniversaryMonthTimestamp &&
        $scope.anniversaryData.anniversaryMonthTimestamp >
          $scope.anniversaryData.maximumAnniversaryDate.getTime()
      ) {
        $scope.anniversaryData.anniversaryMonthTimestamp = $scope.anniversaryData.maximumAnniversaryDate.getTime();
        // use lodash invoke to protect against the method not being defined yet. It will be called later if it
        // isn't defined when this is triggered the first time.
        _.invoke($scope, 'anniversaryMonthChanged');
      }
    };

    // Set up custom anniversary dates info
    $scope.anniversaryData = {
      anniversaryMonthTimestamp: null,
      anniversaryTimestamp: null,
      initialTermDuration: 12,
      minimumAnniversaryDate: null,
      maximumAnniversaryDate: null
    };
    calculateExtendedTermDates();

    //Get countries
    $scope.loadingCountries = true;
    CountryList.get()
      .$promise.then(function(countryList) {
        $scope.loadingCountries = false;
        if ($scope.resellerIsChinaOnly) {
          // China-only resellers can only invite customers from China. Restrict country list to China.
          var china = _.filter(countryList.items, ['countryCode', 'CN']);
          $scope.countries = appendPreferredLocales(china);
          // Select China in the dropdown by default, and load up the regions and preferred language for it right away
          if ($scope.countries && $scope.countries.length > 0) {
            $scope.country = $scope.countries[0];
            var requestedRegion;
            // if this is edit instead of add, get the customer's region and pass along when setting
            // the country and fetching regions, so it gets selected in the dropdown properly.
            if ($scope.isEdit && $scope.customer.address) {
              requestedRegion = $scope.customer.address.region;
            }
            $scope.countrySelectionChange(requestedRegion);
          }
        } else {
          // for non-China resellers, filter out China from the countries drop down
          var filteredList = $filter('filter')(countryList.items, {countryCode: '!CN'}, true);
          var sortedCountries = _.orderBy(filteredList, ['countryName']);
          $scope.countries = appendPreferredLocales(sortedCountries);
        }

        if (feature.isEnabled('temp_disable_for_russia')) {
          $scope.countries  = $filter('filter')($scope.countries, {countryCode: '!RU'},  true);
        }

        if(feature.isEnabled('temp_disable_for_belarus')){
          $scope.countries  = $filter('filter')($scope.countries, {countryCode: '!BY'},  true);

        }
      })
      .catch(function(response) {
        $scope.loadingCountries = false;
        CurtainNotifications.show(
          CurtainNotifications.ERROR,
          'addCustomerModal.notifications.noCountries'
        );
        $log.error('Failed to load countries', response.data);
      });

    // Get the regions for a particular country using $scope.country for the countryCode.
    // If initRegion specified will set the initial region in the selector to that, otherwise,
    // it will use the first region in the list of regions for the particular country.
    var initRegionsForCountry = function(initialRegion) {
      if (!$scope.country) {
        return;
      }

      $scope.loadingRegions = true;
      Regions.get($scope.country.countryCode)
        .then(function(responseData) {
          $scope.loadingRegions = false;
          $scope.regions = responseData;
          $scope.region = initialRegion ? initialRegion : responseData[0];
        })
        .catch(function(response) {
          //If the country has no regions, set a single option having the same name as the selected country
          $scope.loadingRegions = false;

          if (response.status !== 0) {
            //Aborted calls can mean new region was requested, cancelling a prior request
            CurtainNotifications.show(
              CurtainNotifications.ERROR,
              'addCustomerModal.notifications.noRegions'
            );
            $log.error('Failed to load regions', response.data);
          }
        });
    };

    function removeFirstCharIfInvalid(value) {
      const arr =  _.split(value, '');
      if (/[!+=/\-@|]/.test(arr[0])) {
        return value.slice(1);
      }
      return value;
    }

    // Only Filtering the first element as we need spaces and certain characters
    // Organization Name validation
    $scope.orgNameChange = function () {
      if ($scope.orgName) {
        $scope.orgName = removeFirstCharIfInvalid($scope.orgName);
      }
    };

    // City validation
    $scope.cityChange = function () {
      if ($scope.city) {
        $scope.city = removeFirstCharIfInvalid($scope.city);
      }
    };

    // Zipcode validaiton
    $scope.zipCodeChange = function () {
      if ($scope.zipCode) {
        $scope.zipCode = removeFirstCharIfInvalid($scope.zipCode);
      }
    };

    // Firstname validation
    $scope.firstNameChange = function () {
      if ($scope.firstName) {
        $scope.firstName = removeFirstCharIfInvalid($scope.firstName);
      }
    };

    // Lastname validation
    $scope.lastNameChange = function () {
      if ($scope.lastName) {
        $scope.lastName = removeFirstCharIfInvalid($scope.lastName);
      }
    };

    // Street1 validation
    $scope.street1Change = function () {
      if ($scope.street1) {
        $scope.street1 = removeFirstCharIfInvalid($scope.street1);
      }
    };

    // Street2 validation
    $scope.street2Change = function () {
      if ($scope.street2) {
        $scope.street2 = removeFirstCharIfInvalid($scope.street2);
      }
    };

    // Email validation
    $scope.emailChange = function () {
      if ($scope.email) {
        $scope.email = removeFirstCharIfInvalid($scope.email);
      }
    };

    //Country dropdown change handler
    $scope.countrySelectionChange = function(requestedRegion) {
      if ($scope.country) {
        //Get regions when country is selected. Pass along any requested initial region.
        initRegionsForCountry(requestedRegion);

        //Update the preferred language dropdown to match the selected country's countryLocale property
        if ($scope.country.countryLocale) {
          //We're setting it to the actual countryLocale (e.g. en) instead of the data provider object ($scope.preferredLanguages)
          //because the ngOptions definition is lang.value as lang.label, meaning the value is lang.value rather than the whole lang object
          $scope.preferredLanguage = _.toLower($scope.country.countryLocale);
        }
      }
    };

    //Cleansed form
    $scope.ASCII_REGEXP = Settings.ASCII_REGEXP;

    var cleanDataFormIsVisible = false;

    //Watch fields that require cleaning
    $scope.$watchCollection('[orgName,street1,street2,city,zipCode]', function(data) {
      var isAsciiOnly = _.every(data, function(value) {
        return Utility.containsOnlyAsciiPrintableChars(value);
      });

      //Toggle clean data form
      if (isAsciiOnly && cleanDataFormIsVisible) {
        cleanDataFormIsVisible = false;
        $scope.showCleanDataForm = cleanDataFormIsVisible;
      } else if (!isAsciiOnly && !cleanDataFormIsVisible) {
        cleanDataFormIsVisible = true;
        $scope.showCleanDataForm = cleanDataFormIsVisible;
      }

      //If the clean data form is hidden, autocomplete it.
      //This serves 2 purposes:
      // - Form passes validation when submitting data that does not require cleansed data
      // - If form requires clean data, all previous values will be already set
      if (!cleanDataFormIsVisible) {
        autocompleteCleanDataForm();
      }
    });

    //Copy data to cleansed data form
    var autocompleteCleanDataForm = function() {
      $scope.orgNameClean = $scope.orgName;
      $scope.street1Clean = $scope.street1;
      $scope.street2Clean = $scope.street2;
      $scope.cityClean = $scope.city;
      $scope.zipCodeClean = $scope.zipCode;
    };

    // Customer has more keys than the payload. These have to be removed so that we can do a
    // toJson on the starting payload and the ending payload to know if any form fields have
    // been changed.
    var initPayloadFromCustomer = function() {
      var payload = $scope.customer
        ? {
            name: $scope.customer.name,
            cleansedName: $scope.customer.cleansedName,
            marketSegment: $scope.customer.marketSegment,
            address: $scope.customer.address,
            cleansedAddress: $scope.customer.cleansedAddress,
            admin: $scope.customer.admin,
            preferredLanguage: $scope.customer.preferredLanguage
              ? _.toLower($scope.customer.preferredLanguage)
              : 'en-us',
            usadEnabled: !!$scope.customer.usadEnabled, // user-selected anniversary date
            requestedPlanType: $scope.customer.requestedPlanType,
            anniversaryDate: $scope.customer.anniversaryDate
          }
        : {};

      return payload;
    };

    // Initialize the form models using the given payload.
    // When editing, used to populate the form with the pre-existing values.
    var initModelsFromPayload = function(payload) {
      if (!payload) {
        return;
      }

      $scope.orgName = payload.name;
      $scope.orgNameClean = payload.cleansedName;

      $scope.marketSegment = {
        id: payload.marketSegment
      };

      // Format returned by JIL is currently 'TEAM' or 'EVIP'.
      // If no requestedPlanType, default to team.
      $scope.requestedPlanType = payload.requestedPlanType
        ? payload.requestedPlanType
        : PLAN_TYPE.TEAM;

      if (payload.address) {
        $scope.country = payload.address.country;
        initRegionsForCountry(payload.address.region);

        $scope.street1 = payload.address.street1;
        $scope.street2 = payload.address.street2;

        $scope.city = payload.address.city;
        $scope.zipCode = payload.address.postalCode;
      }

      if (payload.cleansedAddress) {
        $scope.street1Clean = payload.cleansedAddress.street1;
        $scope.street2Clean = payload.cleansedAddress.street2;
        $scope.cityClean = payload.cleansedAddress.city;
        $scope.zipCodeClean = payload.cleansedAddress.postalCode;
      }

      if (payload.admin) {
        $scope.email = payload.admin.email;
        $scope.firstName = payload.admin.first_name;
        $scope.lastName = payload.admin.last_name;
      }

      // To set the default it must point to one of the same objects in the collection used to
      // populate the select list. If for some reason language not found, the admin will be
      // required to select a language before saving changes.
      var lang = getPreferredLanguageObject(payload.preferredLanguage);
      if (lang) {
        $scope.preferredLanguage = lang.value;
      }

      $scope.orgOptions.usadEnabled = payload.usadEnabled;

      if (payload.anniversaryDate) {
        $scope.orgOptions.customInitialTerm = true;
        const payloadAnniversaryDate = new Date(payload.anniversaryDate);
        if ($scope.isEdit) {
          $scope.anniversaryData.anniversaryTimestamp = payloadAnniversaryDate.getTime();
        } else {
          $scope.anniversaryData.anniversaryMonthTimestamp = _.find(
            $scope.customAnniversaryMonths,
            function(month) {
              return (
                month.year === payloadAnniversaryDate.getFullYear() &&
                month.date.getMonth() === payloadAnniversaryDate.getMonth()
              );
            }
          ).timestamp;
          $scope.anniversaryMonthChanged();
          $scope.anniversaryData.anniversaryTimestamp = payloadAnniversaryDate.getTime();
          $scope.anniversaryDateChanged();
        }
      }
    };

    // Initialize the payload using the form models.
    // Used to construct the payload after the form has been submitted.
    var initPayloadFromModels = function(countryName = '', regionName = '') {
      var payload = {
        name: $scope.orgName,
        cleansedName: $scope.orgNameClean,
        marketSegment: $scope.marketSegment.id,
        address: {
          country: $scope.country,
          street1: $scope.street1,
          street2: $scope.street2,
          city: $scope.city,
          region: $scope.region,
          postalCode: $scope.zipCode
        },
        cleansedAddress: {
          country: {
            countryLocale: $scope.country.countryLocale,
            countryCode:  $scope.country.countryCode,
            countryCodeISO3:  $scope.country.countryCodeISO3,
            countryName: countryName || $scope.country.countryName
          },
          street1: $scope.street1Clean,
          street2: $scope.street2Clean,
          city: $scope.cityClean,
          region: {
            regionCode: $scope.region.regionCode,
            regionName: regionName || $scope.region.regionName
          },
          postalCode: $scope.zipCodeClean
        },
        admin: {
          email: $scope.email,
          first_name: $scope.firstName,
          last_name: $scope.lastName
        },
        preferredLanguage: _.toLower($scope.preferredLanguage),
        //Make sure usadEnabled is boolean, Angular sets it to undefined if not touched by
        //the user.
        usadEnabled: !!$scope.orgOptions.usadEnabled, // user-selected anniversary date
        requestedPlanType: $scope.requestedPlanType
      };

      // If a custom anniversary date has been chosen, pass it along.
      if ($scope.orgOptions.customInitialTerm && $scope.anniversaryData.anniversaryTimestamp) {
        payload.anniversaryDate = new Date(
          $scope.anniversaryData.anniversaryTimestamp
        ).toISOString();
      }

      return payload;
    };

    // Navigation
    $scope.nextOptions = function() {
      // Move to the next state
      if ($scope.viewState === ADD_CUSTOMER_MODAL_VIEW_STATE.BASIC_INFO) {
        $scope.viewState = ADD_CUSTOMER_MODAL_VIEW_STATE.ORG_OPTIONS;
      }
    };

    $scope.backOptions = function() {
      // Move to prior state
      if ($scope.viewState === ADD_CUSTOMER_MODAL_VIEW_STATE.ORG_OPTIONS) {
        $scope.viewState = ADD_CUSTOMER_MODAL_VIEW_STATE.BASIC_INFO;
      }
    };

    $scope.isMarketSegmentEnabled = function(segment) {
      var selectedCountry = $scope.country;

      // if FF is disabled, all market segments should be enabled
      if (feature.isDisabled('temp_restrict_vip_creation')) {
        return true;
      }

      /* A marketSegment is enabled if a Reseller has permissions to create customers in the market segment or the VIP country selected is allowlisted */
      var isMarketSegmentAllowed = !_.isUndefined(segment)
                                   && _.includes(User.getReseller().allowedMarketSegments, segment.id);

      var isVIPCountryAllowed = !_.isUndefined(selectedCountry)
                                && _.includes(User.getReseller().allowedCountries, selectedCountry.countryCode);

      return isMarketSegmentAllowed || isVIPCountryAllowed;
    };

    // recalculate anniversary date options based on market segment
    $scope.segmentSelectionChange = function() {
      calculateExtendedTermDates();
    };

    $scope.customAnniversaryToggle = function() {
      if ($scope.orgOptions.customInitialTerm) {
        $scope.anniversaryData.anniversaryMonthTimestamp =
          $scope.anniversaryData.anniversaryMonthTimestamp ||
          $scope.anniversaryData.minimumAnniversaryDate.getTime();
        $scope.anniversaryMonthChanged();
      }
    };

    // Custom anniversary date options
    $scope.anniversaryMonthChanged = function() {
      $scope.customAnniversaryDays = [];
      if (!$scope.anniversaryData.anniversaryMonthTimestamp) {
        return;
      }
      $scope.anniversaryData.anniversaryTimestamp =
        $scope.anniversaryData.anniversaryMonthTimestamp;
      $scope.customAnniversaryDays = AnniversaryDatesUtility.getAnniversaryDaysForMonth(
        $scope.anniversaryData
      );
      $scope.anniversaryDateChanged();
    };

    $scope.anniversaryDateChanged = function() {
      if (!$scope.anniversaryData.anniversaryTimestamp) {
        return;
      }

      // compute subscription license period (in months)
      const momentAnniversary = moment($scope.anniversaryData.anniversaryTimestamp);
      const momentTodayPacificTime = moment()
        .tz('America/Los_Angeles')
        .startOf('day')
        .minute(1);
      const monthsBetween = momentAnniversary.diff(momentTodayPacificTime, 'months');
      $scope.anniversaryData.initialTermDuration = monthsBetween;
    };

    //Submit
    //Control vars for UI validation errors
    $scope.submitAttempted = false; //Was submit button clicked?

    // We're editing. Populate the modal models with the existing customer data.
    if ($scope.isEdit) {
      var customerPayload = initPayloadFromCustomer();
      initModelsFromPayload(customerPayload);
    }

    var resetSubmit = function() {
      AddCustomerModal.unsetLoadingState();
      $scope.submitted = false;
      $scope.submitAttempted = false;
    };

    $scope.submit = function() {
      const updateInvitationBanner = 'editCustomerModal.notifications.submitSuccess';
      if (!$scope.submitted) {
        $scope.submitAttempted = true;

        if ($scope.customerForm.$valid) {
          $scope.submitted = true;
          AddCustomerModal.setLoadingState();

          let countryName = '';
          let regionName = '';
          if (locale.getActiveLocaleCode() !== 'en_US') {
            IMSClient.getCountries('en_US')
            .then(function(res) {
              $scope.loadingCountries = false;
              const payLoadCountry = _.filter(res.data.countries, ({countryCode}) => countryCode === $scope.country.countryCode);
              if (payLoadCountry.length) {
                //overriding with en country name.
                countryName = payLoadCountry[0].countryName;
              }

              IMSClient.getRegions({locale: 'en_US', countryCode: $scope.country.countryCode})
              .then(function(res) {
                $scope.loadingCountries = false;
                const payLoadRegion = _.filter(res.data.regions, ({regionCode}) => regionCode === $scope.region.regionCode);
                if (payLoadRegion.length) {
                  //overriding with en country name.
                  regionName = payLoadRegion[0].regionName;
                }
                //Structure data as needed by API
                var payload = initPayloadFromModels(countryName, regionName);

                if (!$scope.isEdit || $scope.customerForm.$dirty) {
                  var customerFunc = function() {
                    return $scope.isEdit
                      ? Customer.update($scope.customer.id, payload)
                      : Customers.invite(payload);
                  };

                  customerFunc()
                    .then(function(responseData) {
                      var msg = $scope.isEdit
                        ? updateInvitationBanner
                        : 'addCustomerModal.notifications.submitSuccess';

                      CurtainNotifications.show(CurtainNotifications.SUCCESS, msg, {
                        email: $scope.email
                      });
                      AddCustomerModal.remove({
                        response: responseData
                      });
                    })
                    .catch(function(response) {
                      $log.warn(response.data, response.status);

                      if (response.status !== 0) {
                        //status is 0 when call is aborted
                        //Get first character from HTTP status as number
                        var statusType = +('' + response.status).charAt(0);

                        if (
                          $scope.isEdit &&
                          statusType === 4 &&
                          response.data.errorCode === 'INVITE_ALREADY_ACCEPTED'
                        ) {
                          CurtainNotifications.show(
                            CurtainNotifications.NOTICE,
                            'editCustomerModal.notifications.invitationAlreadyAccepted'
                          );
                          AddCustomerModal.remove({refreshCustomers: true});
                        } else if (
                          response.status === 409 &&
                          response.data.errorCode === 'CUSTOMER_ALREADY_HAS_ORG'
                        ) {
                          AddCustomerModal.remove({
                            response: {email: $scope.email, userHasDifferentAdobeAccount: true}
                          });
                        } else if (statusType === 4 || statusType === 5) {
                          CurtainNotifications.show(
                            CurtainNotifications.ERROR,
                            'generic.notifications.error'
                          );
                          resetSubmit();
                          $log.error('Failed to create or update the invite', response.data);
                        }
                      }
                    });
                } else {
                  // Skip the call to JIL to update the customer if the form didn't change.
                  CurtainNotifications.show(
                    CurtainNotifications.SUCCESS,
                    updateInvitationBanner,
                    {email: $scope.email}
                  );
                  $scope.removeModal();
                }
              })
              .catch(function(response) {
                $scope.loadingCountries = false;
                CurtainNotifications.show(
                  CurtainNotifications.ERROR,
                  'addCustomerModal.notifications.noCountries'
                );
                $log.error('Failed to load countries', response.data);
              });
            })
            .catch(function(response) {
              $scope.loadingCountries = false;
              CurtainNotifications.show(
                CurtainNotifications.ERROR,
                'addCustomerModal.notifications.noCountries'
              );
              $log.error('Failed to load countries', response.data);
            });
          } else {

            //Structure data as needed by API
            var payload = initPayloadFromModels(countryName, regionName);

            if (!$scope.isEdit || $scope.customerForm.$dirty) {
              var customerFunc = function() {
                return $scope.isEdit
                  ? Customer.update($scope.customer.id, payload)
                  : Customers.invite(payload);
              };

              customerFunc()
                .then(function(responseData) {
                  var msg = $scope.isEdit
                    ? updateInvitationBanner
                    : 'addCustomerModal.notifications.submitSuccess';

                  CurtainNotifications.show(CurtainNotifications.SUCCESS, msg, {
                    email: $scope.email
                  });
                  AddCustomerModal.remove({
                    response: responseData
                  });
                })
                .catch(function(response) {
                  $log.warn(response.data, response.status);

                  if (response.status !== 0) {
                    //status is 0 when call is aborted
                    //Get first character from HTTP status as number
                    var statusType = +('' + response.status).charAt(0);

                    if (
                      $scope.isEdit &&
                      statusType === 4 &&
                      response.data.errorCode === 'INVITE_ALREADY_ACCEPTED'
                    ) {
                      CurtainNotifications.show(
                        CurtainNotifications.NOTICE,
                        'editCustomerModal.notifications.invitationAlreadyAccepted'
                      );
                      AddCustomerModal.remove({refreshCustomers: true});
                    } else if (
                      response.status === 409 &&
                      response.data.errorCode === 'CUSTOMER_ALREADY_HAS_ORG'
                    ) {
                      AddCustomerModal.remove({
                        response: {email: $scope.email, userHasDifferentAdobeAccount: true}
                      });
                    } else if (statusType === 4 || statusType === 5) {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'generic.notifications.error'
                      );
                      resetSubmit();
                      $log.error('Failed to create or update the invite', response.data);
                    }
                  }
                });
            } else {
              // Skip the call to JIL to update the customer if the form didn't change.
              CurtainNotifications.show(
                CurtainNotifications.SUCCESS,
                updateInvitationBanner,
                {email: $scope.email}
              );
              $scope.removeModal();
            }
          }
        }
      }
    };

    //Close modal
    $scope.removeModal = function() {
      //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
      AddCustomerModal.remove({cancelled: true});
    };
  }
})();
